import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Pagination,
  Button,
} from "@mui/material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { my_residential_plots, get_plot_store_delete, renew_plot } from "../../../api/ControllApi";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ResidentialDocPayDialog from "./ResidentialDocPayDialog";
import { useSettings } from "../../../context/Settings";

const MyResidentialList = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const { settings } = useSettings()
  const [loading, setLoading] = useState(true);

  const handleMenuOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  const [residentialList, setResidentialList] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(0);


  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openVerifyDialog, setOpenVerifyDialog] = useState(false);

  const totalAmount = settings?.data?.market_plot_verify_amount || 499

  // 🔹 API CALL
  const getResidentialList = async () => {
    try {
      setLoading(true); // Start loading
      const res = await my_residential_plots(); // Wait for API
      setResidentialList(res?.data?.plots || []);
      setRowsPerPage(res?.data?.pagination.per_page)
      // Set data
    } catch (err) {

    } finally {
      setLoading(false); // Stop loading
    }
  };


  useEffect(() => {
    getResidentialList();
  }, []);
  const getDelete = (id) => {
    get_plot_store_delete(id)
      .then((res) => {
        toast.success(res?.message)

        getResidentialList();

      })
      .catch((err) => {

      });
  };

  const handleRenew = async (id) => {
    try {
      const res = await renew_plot(id);
      if (res?.status === true || res?.success === true || res?.status === "success" || res) {
        toast.success(res?.message || "Plot renewed successfully");
        setResidentialList(prev => prev.map(p => p.id === id ? { ...p, is_active: true } : p));
        getResidentialList();
      } else {
        toast.error(res?.message || "Failed to renew plot");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong during renewal");
    }
  };


  // 🔹 SEARCH FILTER
  const filteredData = residentialList.filter((item) =>
    item?.property_name?.toLowerCase().includes(search.toLowerCase())
  );

  // 🔹 PAGINATION
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  {/* PAGINATION */ }
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  return (
    <Box>
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
          mb: 2,
        }}
      >
        <Typography variant="h5" fontWeight={500}>
          My Flats / Villas List
        </Typography>

        {/* <TextField
          label="Search property..."
          size="small"
          sx={{ width: { xs: "100%", sm: 250 } }}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        /> */}

        <Button
          variant="contained"
          sx={{ gap: 1 }}
          onClick={() => navigate("/add-residential-property")}
        >
          <AddIcon fontSize="small" />
          Add Flat / Villas
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 3,
          // maxHeight: 400,       
          overflowY: "auto",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow sx={{ bgcolor: "primary.light" }}>
              {/* <TableCell>ID</TableCell> */}
              <TableCell>Property Name</TableCell>
              <TableCell>Location</TableCell>
              {/* <TableCell><b>Price (₹)</b></TableCell>
              <TableCell><b>Area (sqft)</b></TableCell> */}
              <TableCell>Posted On</TableCell>
              <TableCell>Verify Plot</TableCell>
              {/* <TableCell><b>Status</b></TableCell> */}
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ?
              <TableRow>
                <TableCell colSpan={7} align="center">
                  Loading...
                </TableCell>
              </TableRow>
              : paginatedData.length > 0 ? (
                paginatedData.map((item) => (
                  <TableRow key={item.id}>
                    {/* <TableCell>{item.id}</TableCell> */}
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1.5}>
                        <Typography variant="body2">{item.property_name}</Typography>
                        {!(
                          item?.is_active === true ||
                          item?.is_active === 1 ||
                          String(item?.is_active).toLowerCase() === "true" ||
                          String(item?.is_active) === "1"
                        ) && (
                          <Button
                            size="small"
                            variant="contained"
                            sx={{
                              bgcolor: "#FEB821",
                              color: "#fff",
                              fontWeight: 600,
                              textTransform: "none",
                              borderRadius: "6px",
                              py: 0.25,
                              px: 1,
                              minWidth: "auto",
                              "&:hover": {
                                bgcolor: "#e09a1f",
                              }
                            }}
                            onClick={() => handleRenew(item.id)}
                          >
                            Renew
                          </Button>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {console.log("Plot item:", item.property_name, "is_active:", item.is_active)}
                      {item.location?.length > 25
                        ? item.location.slice(0, 25) + "..."
                        : item.location}
                    </TableCell>
                    {/* <TableCell>{item.price} </TableCell>
                    <TableCell>{item.area_sqft_price}</TableCell> */}
                    <TableCell>
                      {new Date(item.created_at).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}

                    </TableCell>
                    {/* <TableCell>
              {item.verify_status === 1 ? "Verified" : "Pending"}
            </TableCell> */}
                    {/* ACTION */}
                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {

                          if (item?.doucment_verficaiton === false) {
                            setSelectedProperty(item);
                            setOpenVerifyDialog(true);
                          }

                          return

                        }}

                      >
                        {item?.doucment_verficaiton === false ? "Pay" : "Paid"}
                      </Button>



                    </TableCell>

                    <TableCell align="center">
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuOpen(e, item)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No Flats/ Villas Property Found
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            navigate(`/edit-residential-property/${selectedItem?.id}`);
            handleMenuClose();
          }}
          sx={{ gap: 1 }}
        >
          <EditIcon fontSize="small" />
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {

            getDelete(selectedItem?.id);
            handleMenuClose();
          }}
          sx={{ gap: 1, color: "error.main" }}
        >
          <DeleteIcon fontSize="small" />
          Delete
        </MenuItem>
      </Menu>




      {!loading && filteredData.length > rowsPerPage && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={Math.ceil(filteredData.length / rowsPerPage)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}

      <ResidentialDocPayDialog
        open={openVerifyDialog}
        totalPayableAmount={totalAmount}
        property_id={selectedProperty?.id}
        property_name={selectedProperty?.property_name}
        property_location={selectedProperty?.location}
        onClose={() => {
          setOpenVerifyDialog(false);
          setSelectedProperty(null);
        }}
      />

    </Box>
  );
};

export default MyResidentialList;
